import { Component, Injector, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from '@node_modules/rxjs/observable/forkJoin';
import { AppConsts } from '@shared/AppConsts';
import { TransactionStatusEnum } from '@shared/AppEnums';
import { AppComponentBase } from '@shared/common/app-component-base';
import { QrMenaMenuItem, QrMenaMenuItemServiceProxy, QrMenaSaleTransactionDetialDto, QrMenaSaleTransactionDto, QrMenaSaleTransactionsDiningTableDto, QrMenaSaleTransactionServiceProxy } from '@shared/service-proxies/service-proxies';
import { generateGuid, InvoiceDtlItem, InvoiceHeader } from 'QrMena/models/qrmena-invoice-model';
@Component({
    selector: 'app-items-container-component',
    templateUrl: './items-container.component.html',
    styleUrls: ['./items-container.component.css']
})
export class ItemsContianerComponent extends AppComponentBase
    implements OnInit {

    invoice: InvoiceHeader
    items: QrMenaMenuItem[] = []
    renderedItems: QrMenaMenuItem[] = []
    showCategories: boolean
    showInvoice: boolean
    showErrMsg: boolean
    issuccess: boolean
    showOverLay: boolean
    searchText: string = ''
    errormessage: string
    isEdit: boolean = false;
    constructor(injector: Injector, private menuItemsService: QrMenaMenuItemServiceProxy,
        private _qrmenasSaleTransactionService: QrMenaSaleTransactionServiceProxy, private _router: Router) {
        super(injector);
        this.invoice = new InvoiceHeader()
    }
    ngOnInit(): void {
        this.showOverLay = true
        forkJoin(this.menuItemsService.getMenuitemsList(Number(abp.utils.getCookieValue(AppConsts.appSessionItems.storeId))), this._qrmenasSaleTransactionService.getTableInvoice(Number(abp.utils.getCookieValue(AppConsts.appSessionItems.tableId)))).subscribe(res => {
            console.log(res);
            this.items = res[0]
            this.renderedItems = res[0]
            if (res[1] && res[1].id) {
                // map invoice current invoice

                this.invoice.id = res[1].id,
                    this.invoice.total = res[1].total;
                this.invoice.subTotal = res[1].subTotal;
                this.invoice.vat = res[1].vat;
                this.invoice.saleTransactionDetails = res[1].detailSaleTransaction.map(ele => {
                    let invoiceDetail: InvoiceDtlItem = new InvoiceDtlItem();
                    invoiceDetail.productId = ele.menuItemId;
                    invoiceDetail.price = ele.price;
                    invoiceDetail.priceIncludeVat = ele.priceIncludeVAT;
                    invoiceDetail.vat = ele.vat;
                    invoiceDetail.id = ele.id
                    invoiceDetail.quantity = ele.quantity
                    invoiceDetail.saleTransactionId = ele.saleTransactionId
                    invoiceDetail.vatBeforeDiscount=ele.vatBeforeDiscount
                    invoiceDetail.isEdit = true;
                    let item = this.items.filter(ite => ite.menuItemId == ele.menuItemId);
                    if (item && item.length > 0) {
                        invoiceDetail.name = item[0].name;
                        invoiceDetail.imgUrl = item[0].imageUrl;


                    }
                    return invoiceDetail

                });
                this.isEdit = true;
                
            }
            this.showOverLay = false
        }, err => {
            this.showOverLay = false
        })
    }

    handelShowCategories() {
        this.showCategories = true
    }
    handelShowInvoice() {
        this.showInvoice = true
    }
    handelSearchItems() {
        this.renderedItems = this.items.filter(ele => ele.name.includes(this.searchText) || !this.searchText.trim())
    }

    handelFilterUsingCategory(categoryId: number) {
        this.renderedItems = this.items.filter(ele => ele.categoryId == categoryId);
    }
    handelShowAllItems() {
        this.searchText = null
        this.renderedItems = this.items
    }

    handleHidCategories($event: any) {
        this.showCategories = false
    }
    handleHidInvoice($event: any) {
        this.showInvoice = false
    }
    handelAddItemToInvoice(input: InvoiceDtlItem) {
        this.invoice.saleTransactionDetails.push(input)
        this.showErroMssage("Item Added Successfuly", true)
        this.calculateSummary()
    }
    calculateSummary() {
        this.invoice.reset()
        this.invoice.saleTransactionDetails.forEach(ele => {
            this.invoice.total += ele.quantity * ele.priceIncludeVat
            this.invoice.subTotal += ele.quantity * ele.price
            this.invoice.vat += ele.quantity * ele.vat
        })
        this.invoice.fixSummary()
        console.log(this.invoice)
    }
    handelChangeQty(input: { qty: number, recordId: string }) {
        console.log(input)
        let itemIndex = this.invoice.saleTransactionDetails.findIndex(ele => ele.id == input.recordId);
        if (itemIndex >= 0)
            this.invoice.saleTransactionDetails[itemIndex].quantity = input.qty
        this.calculateSummary()
    }
    handelRemoveItem(index: string) {
        let itemIndex = this.invoice.saleTransactionDetails.findIndex(ele => ele.id == index);

        if (itemIndex >= 0)
            this.invoice.saleTransactionDetails.splice(itemIndex, 1)
        this.calculateSummary()
    }
    showErroMssage(message: string, success: boolean) {
        this.errormessage = message
        this.showErrMsg = true;
        this.issuccess = success
        setTimeout(() => {
            this.showErrMsg = false
        }, 1000);
    }

    handelSaveInvoice() {
        if (!this.invoice || !this.invoice.saleTransactionDetails || this.invoice.saleTransactionDetails.length == 0) {
            this.showErroMssage("Please Add Items To The Order", false)
        }
        else {
            if (!this.isEdit) {

                let invoiceModel: QrMenaSaleTransactionDto = new QrMenaSaleTransactionDto();
                invoiceModel.cashierId = Number(abp.utils.getCookieValue(AppConsts.appSessionItems.userId))
                invoiceModel.id = this.invoice.id
                invoiceModel.total = this.invoice.total;
                invoiceModel.subTotal = this.invoice.subTotal;
                invoiceModel.vat = this.invoice.vat;
                
                invoiceModel.status = TransactionStatusEnum.Ordered; // updated invoice
                invoiceModel.recieptNumber = this.ReceiptID(abp.utils.getCookieValue(AppConsts.appSessionItems.storeId,))
                invoiceModel.storeId = Number(abp.utils.getCookieValue(AppConsts.appSessionItems.storeId,))
                invoiceModel.detailSaleTransaction = this.invoice.saleTransactionDetails.map(ele => {
                    let item: QrMenaSaleTransactionDetialDto = new QrMenaSaleTransactionDetialDto()

                    item.menuItemId = ele.productId;
                    item.price = ele.price;
                    item.priceIncludeVAT = ele.priceIncludeVat;
                    item.vat = ele.vat;
                    item.id = ele.id
                    item.quantity = ele.quantity
                    ele.saleTransactionId = invoiceModel.id
                    item.vatBeforeDiscount=ele.vatBeforeDiscount

                    return item;
                })
                invoiceModel.qrMenaSaleTransactionsDiningTables = [new QrMenaSaleTransactionsDiningTableDto({ isSplit: false, numberOfSeats: 0, qrMenaSaleTransactionId: this.invoice.id, tableId: Number(abp.utils.getCookieValue(AppConsts.appSessionItems.tableId)), id: generateGuid() })]

                this.showOverLay = true
                this._qrmenasSaleTransactionService.qrMenaSaveDinInInvoice(invoiceModel).subscribe(res => {
                    this.invoice = new InvoiceHeader()
                    this.showOverLay = false
                    this.handleHidInvoice(false)
                    this.showErroMssage(this.l("OrderSaved"), true)
                    this.isEdit = false;
                }, error => {
                    this.showOverLay = false
                })
            }
            else {
                let invoiceModel: QrMenaSaleTransactionDto = new QrMenaSaleTransactionDto();
                invoiceModel.cashierId = Number(abp.utils.getCookieValue(AppConsts.appSessionItems.userId))
                invoiceModel.id = this.invoice.id
                invoiceModel.total = this.invoice.total;
                invoiceModel.subTotal = this.invoice.subTotal;
                invoiceModel.vat = this.invoice.vat;
                invoiceModel.storeId = Number(abp.utils.getCookieValue(AppConsts.appSessionItems.storeId,))
                invoiceModel.recieptNumber = this.ReceiptID(abp.utils.getCookieValue(AppConsts.appSessionItems.storeId,))
                invoiceModel.status = TransactionStatusEnum.Ordered; // updated invoice
                invoiceModel.detailSaleTransaction = this.invoice.saleTransactionDetails.map(ele => {
                    let item: QrMenaSaleTransactionDetialDto = new QrMenaSaleTransactionDetialDto()

                    item.menuItemId = ele.productId;
                    item.price = ele.price;
                    item.priceIncludeVAT = ele.priceIncludeVat;
                    item.vat = ele.vat;
                    item.id = ele.id
                    item.quantity = ele.quantity
                    ele.saleTransactionId = invoiceModel.id
                    item.vatBeforeDiscount=ele.vatBeforeDiscount
                    return item;
                })
                invoiceModel.qrMenaSaleTransactionsDiningTables = [new QrMenaSaleTransactionsDiningTableDto(
                    { isSplit: false, numberOfSeats: 0, qrMenaSaleTransactionId: this.invoice.id, tableId: Number(abp.utils.getCookieValue(AppConsts.appSessionItems.tableId)), id: generateGuid() })

                ]
                let paremters = {
                    tenantId: abp.multiTenancy.getTenantIdCookie(),
                    pincode: abp.utils.getCookieValue(AppConsts.appSessionItems.pinCode),
                    storied: abp.utils.getCookieValue(AppConsts.appSessionItems.storeId),
                    tableId: abp.utils.getCookieValue(AppConsts.appSessionItems.tableId)
                }

                let homepageNavigation: any = [`/QRMENA/home`, {
                    data: btoa(JSON.stringify(paremters)),
                }]
                if (!this.isEdit) {


                    this.showOverLay = true
                    this._qrmenasSaleTransactionService.qrMenaSaveDinInInvoice(invoiceModel).subscribe(res => {
                        this.invoice = new InvoiceHeader()
                        this.showOverLay = false
                        this.handleHidInvoice(false)
                        this.showErroMssage(this.l("OrderSaved"), true)
                        this.isEdit = false;
                        this._router.navigate(homepageNavigation);
                    }, error => {
                        this.showOverLay = false
                    })
                } else {
                    this.showOverLay = true
                    this._qrmenasSaleTransactionService.qrMenaUpdateDinInInvoice(invoiceModel).subscribe(res => {
                        this.invoice = new InvoiceHeader()
                        this.showOverLay = false
                        this.handleHidInvoice(false)
                        this.showErroMssage(this.l("OrderSaved"), true)
                        this.isEdit = false;
                        this._router.navigate(homepageNavigation);
                    }, error => {
                        this.showOverLay = false
                    })
                }
            }
        }

    }

    ReceiptID(storeId): string {

        return ((new Date()).getTime() + Number(storeId)).toString();
    }
}




// WEBPACK FOOTER //
// ./src/QrMena/components/items-container-component/items-container.component.ts